import dayjs from 'dayjs';
import { useMemo } from 'react';
import { BlogLangType } from '../../types/blogTypes';

const TIMEZONE_BY_LANG: Record<BlogLangType, string> = {
    ko: 'Asia/Seoul',
    ja: 'Asia/Tokyo',
    en: 'America/New_York',
    de: 'Europe/Berlin',
    es: 'Europe/Madrid',
    fr: 'Europe/Paris',
    it: 'Europe/Rome',
    nl: 'Europe/Amsterdam',
    pt: 'America/Sao_Paulo',
};

/**
 * 한국 시간(=디비의 시간)을 지역 시간으로 변환
 */
export const useRegionTime = (timeStr: string, lang: BlogLangType, format: string): string => {
    let timezone = TIMEZONE_BY_LANG[lang];

    if (!timezone) {
        timezone = 'Asia/Seoul';
    }

    const dateAtRegion = useMemo(() => {
        return dayjs(timeStr).tz(timezone, true).format(format);
    }, [timeStr, timezone, format]);

    return dateAtRegion;
};
